<a
  [href]="logoUrl"
  class="med-header__link"
>
  <img
    [src]="headerAppLogo"
    alt="Logo"
    class="med-header__logo"
  />
</a>

<div
  class="med-header__content"
  [style.justify-content]="justifyContent"
>
  <ng-content></ng-content>
</div>
